'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.appParam', [])

.factory('appParamService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/AppParam';

    service.getNewIamUrl = function () {
        return $http.get(baseUrl + '/NewIamUrl')
            .then(function (response) {
                return response.data;
            });
    };

    service.getAppParam = function (name) {
        return $http.get(baseUrl + '/' + name, {})
            .then(function (response) {
                return response.data;
            });
    };

    return service;
}]);
